import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Data_Recycle_Annexe_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Data_Recycle_Annexe.interface';

import { Data_Check, Filter_Check_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Filter_Check_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-recycle-bin-anne-fin',
    templateUrl: './recycle-bin-anne-fin.component.html',
    styleUrls: ['./recycle-bin-anne-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/RecycleBinAnnexe.scss'],
    standalone: false
})
export class RecycleBinAnneFINComponent implements OnInit {

  //+================== VARIABLES FOR HEADERS RB ==================+\\
  public HeadersRB: Headers_CCP[] = [
    { ID: 1, Name: 'Icono', Position: 1, Visible: true, Key_Header: 'ICONF' },
    { ID: 1, Name: 'Nombre de anexo', Position: 1, Visible: true, Key_Header: 'NAMFI' },
    { ID: 1, Name: 'Nombre de Proceso', Position: 1, Visible: true, Key_Header: 'NAMAN' },
    { ID: 1, Name: 'Revisión', Position: 1, Visible: true, Key_Header: 'NOREV' },
    { ID: 1, Name: 'Fecha de eliminación', Position: 1, Visible: true, Key_Header: 'DATED' },
    { ID: 1, Name: '', Position: 1, Visible: true, Key_Header: 'DELET' },
  ]


  //+================== VARIABLES FOR SEARCH ==================+\\
  public Filter_RecycleBin: string = '';


  //+================== VARIABLE FOR ALL RECYCLE BIN FIN ==================+\\
  public List_RecycleBin: Data_Recycle_Annexe_FIN[] = [];
  public SelectedList_RecycleBin: Data_Recycle_Annexe_FIN[] = [];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_FIN = {
    Extension: [],
    Status: [],
    Revision_No: [],
    Approver1_Name: [],
    Approver2_Name: [],
    Approver3_Name: [],
    Approver4_Name: [],
    Contributor_Name: [],
  };

  //+================== VARIABLES FOR REGULAR EXPRESION ==================+\\
  private Expression1: RegExp = /[/]+[0-9]+§/

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+================== VARIABLE FOR ALL VERSION FIN ==================+\\
  public LoadPage: boolean = false;
  public CurrentLibrarySlug: string = 'fin';


  //-========================= SERVICES =========================-\\
  private Service_FIN = inject(LibraryFINService);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.CurrentLibrarySlug = (this.route.snapshot.paramMap.get('libSlug') || 'fin').toLowerCase();
    this.Load_Component_RB();
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_RB(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {
      this.List_RecycleBin = [];

      const ResRecycleBin: Response_FIN = await firstValueFrom(this.Service_FIN.Get_All_Recycle_Annexe_FIN(this.CurrentLibrarySlug));

      if (ResRecycleBin.success) {
        this.List_RecycleBin = ResRecycleBin.operation;

      }

      Loader.classList.remove('active');
      this.LoadPage = true;

      this.Generate_Filters();


    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar la papelera de reciclaje, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //-================== FUNCTION TO RESTORE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR RESTORE FILE FIN ==============\\
  public Restore_File_FIN(FileRecycle: Data_Recycle_Annexe_FIN): void {

    Swal.fire({
      title: '¿Está seguro de restaurar el Proceso?',
      text: "¡No podrá recuperar el Proceso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, restaurar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para restaurar el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Restaurar Proceso',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result.isConfirmed) {

            if (result2.value === 1) {

              try {

                const ResMoveRBin: Response_FIN = await firstValueFrom(this.Service_FIN.Restore_Annexe_FIN({ ID: FileRecycle.ID }, this.CurrentLibrarySlug));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Proceso restaurado`,
                    text: `¡Se restauró correctamente el proceso!`,
                    confirmButtonColor: this.ColorConfirm
                  });

                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al restaurar el proceso`,
                  text: `¡No se restauró el proceso, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });

                this.Load_Component_RB();


              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para restaurar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

            }

          }


        }))
      }
    })

  }


  //-================== FUNCTION TO DELETE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR DELETE FILE FIN ==============\\
  public Delete_File_Permanently_FIN(FileRecycle: Data_Recycle_Annexe_FIN): void {

    Swal.fire({
      title: '¿Está seguro de eliminar el Proceso permanentemente?',
      text: "¡No podrá recuperar el Proceso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar permanentemente!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para eliminar permanentemente el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Eliminar Proceso permanentemente',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result2.isConfirmed) {

            if (result2.value===1) {

              try {

                const ResMoveRBin: Response_FIN = await firstValueFrom(this.Service_FIN.Deleted_Permanently_Annexe_FIN({ ID: FileRecycle.ID }, this.CurrentLibrarySlug));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: `Proceso eliminado permanentemente`,
                    text: `¡Se eliminó correctamente el proceso!`,
                    confirmButtonColor: this.ColorConfirm
                  });

                  this.Load_Component_RB();
                }


              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: `Error al eliminar el proceso`,
                  text: `¡No se eliminó el proceso, notifica a tu supervisor!`,
                  confirmButtonColor: this.ColorConfirm
                });

                this.Load_Component_RB();


              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para eliminar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

            }

          }


        }))
      }
    })

  }




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Status: [],
      Revision_No: [],
      Approver1_Name: [],
      Approver2_Name: [],
      Approver3_Name: [],
      Approver4_Name: [],
      Contributor_Name: [],
    };

    for (const FIN of this.List_RecycleBin as any) {

      FIN.Date_Deleted = moment(FIN.Date_Deleted).utc().toDate();

      FIN.F_Extension = { Value: FIN.Extension } as Data_Check;
      FIN.F_Revision_No = { Value: FIN.Revision_No } as Data_Check;

      if (!this.Filter_Global_Check.Extension.some(item => item.Value === FIN.Extension) && FIN.Extension !== null) {
        this.Filter_Global_Check.Extension.push({ Value: FIN.Extension })
      }

      if (!this.Filter_Global_Check.Revision_No.some(item => item.Value === FIN.Revision_No) && FIN.Revision_No !== null) {
        this.Filter_Global_Check.Revision_No.push({ Value: FIN.Revision_No })
      }

    }


  }

  //-============== FUNCTION FOR FORMAT DATE DELETED ==============-\\
  public Get_Date_Deleted(Date_Deleted: Date | null): string {
    return moment(Date_Deleted).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


}
